import { getWorkTimeChartDurations } from '@app/shared/components/reports/time-report-panel-chart/services/work-time-chart-durations';
import { TimeReportSessionTypeEnum } from '@app/shared/types/models/reports/time-report-panel.model';
import { TimeReportRowVM } from '@app/shared/types/models/reports/time-report-row.model';
import { isWorkTimeReport } from '@app/shared/types/models/reports/work-time-report';
import { durationToMinutes } from './time-report-chart.aggregation';

export interface TimeReportSumUp {
  ordinaryMinutes: number;
  bankPlusMinutes: number;
  bankMinusMinutes: number;
  overtime50Minutes: number;
  overtime100Minutes: number;
  workTimeTotalMinutes: number;
  absenceTotalMinutes: number;
}

export function emptyTimeReportSumUp(): TimeReportSumUp {
  return {
    ordinaryMinutes: 0,
    bankPlusMinutes: 0,
    bankMinusMinutes: 0,
    overtime50Minutes: 0,
    overtime100Minutes: 0,
    workTimeTotalMinutes: 0,
    absenceTotalMinutes: 0
  };
}

export function aggregateTimeReportSumUp(rows: TimeReportRowVM[]): TimeReportSumUp {
  const totals = emptyTimeReportSumUp();

  for (const row of rows) {
    if (row.kind === 'Absence') {
      totals.absenceTotalMinutes += durationToMinutes(row.duration);
      continue;
    }

    if (row.kind !== 'WorkTime' || !isWorkTimeReport(row.source)) {
      continue;
    }

    const durations = getWorkTimeChartDurations(row.source);
    totals.ordinaryMinutes += durations[TimeReportSessionTypeEnum.STANDARD];
    totals.bankPlusMinutes += durations[TimeReportSessionTypeEnum.BANK_PLUS];
    totals.overtime50Minutes += durations[TimeReportSessionTypeEnum.OVERTIME_50];
    totals.overtime100Minutes += durations[TimeReportSessionTypeEnum.OVERTIME_100];
    totals.workTimeTotalMinutes += durationToMinutes(row.source.duration);
  }

  return totals;
}
